export default __webpack_public_path__ + "static/media/arcelikBayiLogo.fd761fee.png";